import { Component, Input, OnInit, Output,EventEmitter } from '@angular/core';


@Component({
  selector: 'app-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss']
})
export class PopupComponent implements OnInit {
  @Input('displaypopup') displaypopup;
  @Input('popupcontents') popupcontents;
  @Input('nullmessage') nullmessage;
  @Output('closepopup') closepopup = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
    console.log("popup",this.displaypopup);
  }

  closemodel(status){
    this.closepopup.emit(status)
  }


}
